import PropTypes from 'prop-types';
import React from 'react';

import { performSelectClient } from '../../../action/performUserResourceActions';
import { mapOptionTypes } from '../../../util/clientTypesHelper';
import { useTranslation } from '../../hooks/useTranslation';
import styles from './styles.module.styl';

function ClientSelector({ handleSelected, userClientsByType, selectedClientId }) {
  const { t } = useTranslation('core');

  return (
    <div className={`${styles.formGroup} form-group`}>
      <label htmlFor="qs-download-modal-client" className="control-label">
        {t('quickstarts.downloadSampleModal.clientSelector.application', 'Application')}
      </label>
      <select
        name="qs-download-modal-client"
        id="qs-download-modal-client"
        className="form-control"
        onChange={(e) => handleSelected(performSelectClient, e.target.value)}
        value={selectedClientId}
      >
        {mapOptionTypes(userClientsByType)}
      </select>
    </div>
  );
}

ClientSelector.propTypes = {
  handleSelected: PropTypes.func.isRequired,
  userClientsByType: PropTypes.object.isRequired,
  selectedClientId: PropTypes.string,
};

export default ClientSelector;
